<script setup lang="ts">
  import { useGlobalSettingsStore } from '@/stores/GlobalSettings.store'

  const globalSettingsStore = useGlobalSettingsStore()

  await globalSettingsStore.init()
  const { ogImage } = storeToRefs(globalSettingsStore)

  if (ogImage) {
    useSeoMeta({
      ogImage: ogImage.value?.filename + '/m/1200x630',
      twitterImage: ogImage.value?.filename + '/m/1200x630'
    })
  }
</script>
<template>
  <slot />
</template>
